import cn from 'classnames';
import React from 'react';

import type * as ClientTypes from '@src/@types/clienttypes';
import { TickIcon } from '@src/components/icons';
import { considerationTimeRange, humanizeTermRange } from '@src/helpers/common';
import { useDictionariesFieldsMap } from '@src/reducers/dictionaries';

import styles from './styles.module.scss';

interface IListProps {
  className?: string;
  card: ClientTypes.IClientMicrocredit;
}

export const List: React.FC<IListProps> = ({ card, className }) => {
  const dicts = useDictionariesFieldsMap();

  const obtainingMethods = card.obtainingMethod?.map((i) => dicts.microCreditObtainingMethod[i]).join(', ');
  const considerationTime = card.considerationTime && considerationTimeRange(card.considerationTime, 'Быстро');
  const payments = card.paymentFrequency.map((i) => dicts.paymentsFrequency[i]).join(', ');

  return (
    <ul className={cn(styles.list, className)}>
      <li>
        <TickIcon />
        Получение: {obtainingMethods}
      </li>
      <li>
        <TickIcon />
        Рассмотрение: {considerationTime}
      </li>
      <li>
        <TickIcon />
        Погашение: {payments}
      </li>
      {card.termDecision.to && (
        <li>
          <TickIcon />
          Одобрение действует: {humanizeTermRange(card.termDecision)}
        </li>
      )}
    </ul>
  );
};
